// Intent: since the "Więcej" tab gave its bottom-bar slot to the agent-mode
// AGENT tab (2026-07-11), the menu moved behind this avatar button in screen
// headers — the Gmail-style pattern (avatar = account & settings entry) chosen
// over a real drawer to avoid an extra navigation layer.

import { router } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { Pressable, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { AppText } from '@/components/ui/app-text';
import { useAuthStore } from '@/store/auth-store';
import { colors, radius } from '@/theme/tokens';

export function HeaderAvatar() {
  const { t } = useTranslation();
  const account = useAuthStore((s) => s.account);
  const initial = account?.firstName?.charAt(0)?.toUpperCase() ?? null;

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={t('more.title')}
      onPress={() => router.push('/menu')}
      style={{ minWidth: 44, minHeight: 44, alignItems: 'flex-start', justifyContent: 'center' }}
    >
      <View
        style={{
          width: 36,
          height: 36,
          borderRadius: radius.full,
          backgroundColor: account ? colors.navy : colors.primaryTile,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {initial ? (
          <AppText variant="labelLg" color="#FFFFFF">
            {initial}
          </AppText>
        ) : (
          <Ionicons
            name="person-outline"
            size={18}
            color={account ? '#FFFFFF' : colors.navy}
          />
        )}
      </View>
    </Pressable>
  );
}
